export enum WalletTransactionType {
  PRODUCT_FUNDS = 'PRODUCT_FUNDS',
  MY_FUNDS = 'MY_FUNDS',
  INCENTIVE_PROGRAM = 'INCENTIVE_PROGRAM',
  MY_METAL_WEIGHT_RESERVE = 'MY_METAL_WEIGHT_RESERVE',
  CASH = 'CASH',
  MANUAL_TRANSFER = 'MANUAL_TRANSFER',
  INSTANT_TRANSFER = 'INSTANT_TRANSFER',
  PHYSICAL_METAL_WEIGHT = 'PHYSICAL_METAL_WEIGHT'
}
